module.exports = __webpack_public_path__ + "static/media/coffee-break.d4c48fbe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/devdata/resources/coffee-break.jpg
// module id = 525
// module chunks = 0